<template>
  <div class="login pc-login">
    <div class="login_center">
      <img class="logo-img" src="@/assets/dream-logo.png" alt="" />
      <span class="header">Agent Service System</span>
      <div class="phone_box" :class="{ input: inputclass == 1 }">
        <el-select v-model="value" placeholder="">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <input
          type="text"
          class="input1 input-password"
          v-sanitize="/[^0-9]/g"
          v-model="input_phone"
          placeholder="Phone number"
        />
      </div>
      <div v-if="show" class="password-code">
        <div class="code_box">
          <input
            :class="{ input1: true, input: inputclass1 == 1 }"
            v-model="input_code"
            placeholder="Verification code"
            @focus="phonecodefocus"
            @blur="phonecodeblur"
            v-sanitize="/[^0-9]/g"
          />
          <span
            :class="{ send: true, active: lock }"
            @click="verificationCode"
            id="send"
            >{{ sendTitle }}</span
          >
        </div>
        <button @click="login_sms" id="sure">Login</button>
      </div>
      <div v-else class="password-code">
        <div class="phone_code_box">
          <input
            type="password"
            class="input1 input-password"
            v-model="password"
            placeholder="login password"
            v-sanitize
          />
        </div>
        <button class="login" id="sure" @click="login">Login</button>
      </div>
      <div class="login-method">
        <p v-if="!show" class="switchover" @click="switchover(true)">
          login with Verification code
        </p>
        <p v-if="show" class="switchover" @click="switchover(false)">
          login with password
        </p>
        <p class="forget-tab" @click="forgot">forgot password</p>
      </div>
    </div>
  </div>
</template>

<script>
import { isApp } from "@/utils/changeStyle.js";
import appName from "../modules/appName.vue";
export default {
  components: {
    appName
  },
  data() {
    return {
      input_phone: "",
      input_code: "",
      show: false,
      password: "",
      options: [
        // {
        //   label: "+62", value: "62"
        // },
        // {
        //   label: "+60", value: "60"
        // },
        // {
        //   label: "+63", value: "63"
        // },
        // {
        //   label: "+66", value: "66"
        // },
        // {
        //   label: "+84", value: "84"
        // },
        // {
        //   label: "+880", value: "880"
        // },
        // {
        //   label: "+90", value: "90"
        // },
        // {
        //   label: "+91", value: "91"
        // },
        // {
        //   label: "+92", value: "92"
        // },
        // {
        //   label: "+57", value: "57"
        // },
        // {
        //   label: "+55", value: "55"
        // },
        // {
        //   label: "+65", value: "65"
        // },
        // {
        //   label: "+58", value: "58"
        // },
      ],
      value: 62,
      auth_time: 60,
      lock: false,
      inputclass: 0,
      inputclass1: 0,
      islogin: true,
      sendTitle: "Send",
      login_lock: false
    };
  },
  computed: {
    isApp() {
      return isApp();
    }
  },
  created() {
    this.getCountryCode();
  },
  methods: {
    forgot() {
      this.$router.push("/forgot");
    },
    switchover(value) {
      this.show = value;
    },
    login_sms() {
      if (!this.input_code) return;
      if (this.login_lock) return;
      console.log(1888);
      this.login_lock = true;
      this.$http
        .fetchpost(this.$api.node_login_code, {
          nationCode: this.value,
          mobile: this.input_phone,
          code: this.input_code
        })
        .then(res => {
          this.login_lock = false;
          this.loginfun(res);
        });
    },
    loginfun(res) {
      if (res.code == "200") {
        localStorage.setItem("username", res.var.username);
        localStorage.setItem("sid", res.var.sid);
        localStorage.setItem("uid", res.var.familyUid);
        localStorage.setItem("nationCode", this.value);
        let t = new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 30);
        document.cookie = "user=new; expires=" + t.toGMTString();
        if (res.var.familyUid > 0 && res.var.hasAccount) {
          localStorage.setItem(
            "authority",
            // JSON.stringify(["recharge", "record", "auto-top-up"])
            JSON.stringify([
              "recharge",
              "officialrecharge",
              "record",
              "auto-top-up",
              "statistic",
              "dailyrank"
            ])
          );
          this.$router.push("/home/recharge");
        } else if (res.var.familyUid > 0) {
          localStorage.setItem(
            "authority",
            JSON.stringify(["statistic", "dailyrank"])
          );
          this.$router.push("/home/statistic");
        } else if (res.var.hasAccount) {
          localStorage.setItem(
            "authority",
            JSON.stringify([
              "recharge",
              "officialrecharge",
              "record",
              "auto-top-up"
            ])
          );
          this.$router.push("/home/recharge");
        } else {
          localStorage.setItem("authority", JSON.stringify([]));
          this.$router.push("/home");
        }
      } else if (res.code == 1001) {
        this.$message({
          duration: 1000,
          message: res.message,
          type: "warning"
        });
        this.show = true;
      } else if (res.code == 1002) {
        this.$message(res.message);
        setTimeout(() => {
          this.$router.push({
            path: "/forgot",
            query: { nationCode: this.value, mobile: this.input_phone }
          });
        }, 500);
      } else {
        this.$message(res.message);
      }
    },
    verificationCode() {
      if (this.lock) return;
      //获取手机验证码
      this.lock = true;
      this.$http
        .fetchpost(
          this.$api.verificationCode +
            "?nationCode=" +
            this.value +
            "&mobile=" +
            this.input_phone
        )
        .then(res => {
          console.log(res);
          if (res.code == 0) {
            this.getAuthCode();
          } else {
            this.lock = false;
            this.$message({
              duration: 2000,
              message: res.msg,
              type: "warning"
            });
          }
        });
    },

    login() {
      //登陆
      if (!this.password) return;
      if (this.login_lock) return;
      this.login_lock = true;
      if (this.islogin == true) {
        this.islogin = false;
        this.$http
          .fetchpost(this.$api.node_login, {
            nationCode: this.value,
            mobile: this.input_phone,
            password: this.password,
            sign: document.cookie
          })
          .then(res => {
            this.login_lock = false;
            this.loginfun(res);
          });
        this.islogin = true;
      }
    },
    phonefocus() {
      this.inputclass = 1;
    },
    phonecodefocus() {
      this.inputclass1 = 1;
    },
    phoneblur() {
      this.inputclass = 0;
    },
    phonecodeblur() {
      this.inputclass1 = 0;
    },
    getAuthCode() {
      var auth_timeTimer = setInterval(() => {
        this.auth_time--;
        this.sendTitle = `${this.auth_time}s`;
        if (this.auth_time <= 0) {
          this.sendTitle = "Send";
          this.auth_time = 60;
          this.lock = false;
          clearInterval(auth_timeTimer);
        }
      }, 1000);
    },
    getCountryCode() {
      this.$http.fetchget(this.$api.contritycode).then(res => {
        if (res.code == 0) {
          let data = res.data.countries;
          data.forEach(element => {
            this.options.push({
              label: "+" + element,
              value: element
            });
          });
        }
      });
    }
  }
};
</script>
<style scoped lang="scss">
.login {
  color: #acacac;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  .login_center {
    width: 400px;
    height: 430px;
    border-radius: 20px;
    // background-color: #fff;
    border: 1px solid #69ed9d;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    padding: 19px 30px 0 30px;
    box-sizing: border-box;
    position: relative;

    .logo-img {
      border-radius: 50%;
      height: 100px;
      width: 100px;
      position: absolute;
      top: -50px;
      left: 50%;
      transform: translateX(-50%);
      background: #fff;
      border: 1px solid #69ed9d;
    }

    .logo {
      width: 240px;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;

      p {
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
      }

      img {
        width: 20px;
      }

      span {
        font-family: "微软雅黑";
        font-size: 20px;
        color: #3c3c3c;
        font-weight: 1000;
        margin-left: 10px;
      }
    }

    .header {
      font-size: 18px;
      margin: 50px 0;
    }

    .phone_box {
      margin-bottom: 20px;
      color: #3c3c3c;
      width: 100%;
      height: 50px;
      display: flex;
      justify-self: start;
      align-items: center;
      // box-shadow: 0px 0px 10px rgb(24, 23, 23) inset;;
      border-radius: 5px;
      background-color: #f7f6f9;
      overflow: hidden;
      position: relative;
    }

    .phone_box:before {
      z-index: 1;
      content: "";
      position: absolute;
      background-color: #979797;
      height: 20px;
      width: 1px;
      top: 15px;
      right: 239px;
    }

    .code_box {
      width: 100%;
      height: 50px;
      display: flex;
      justify-self: start;
      align-items: center;
      overflow: hidden;
      position: relative;

      .send {
        flex-shrink: 0;
        display: block;
        width: 80px;
        height: 48px;
        border-radius: 5px;
        text-align: center;
        line-height: 48px;
        color: #4ebd7a;
        border: 1px solid #4ebd7a;
        font-size: 18px;
        font-family: ArialMT;
        margin-left: 20px;
        box-sizing: border-box;
        cursor: pointer;
      }

      .active {
        -webkit-filter: grayscale(100%);
        /* Chrome, Safari, Opera */
        filter: grayscale(100%);
        background: rgb(230, 218, 218);
      }

      .send1 {
        border: 1px solid #acacac;
        color: #acacac;
      }
    }

    button {
      width: 100%;
      height: 48px;
      border-radius: 5px;
      text-align: center;
      line-height: 48px;
      background: linear-gradient(270deg, #69ed9d 0%, #bef278 100%);
      color: #ffffff;
      font-size: 18px;
      cursor: pointer;
      margin-top: 20px;
    }
  }
}

.password-code {
  width: 100%;
}

.login-method {
  width: 100%;
  display: flex;
  align-items: center;
  height: 40px;
  justify-content: space-between;
}

.input1 {
  width: 100%;
  height: 50px;
  border-radius: 5px;
  background: #f7f6f9;
  font-size: 15px;
  box-sizing: border-box;
  padding-left: 20px;
}

.span-password {
  margin-top: -20px;
  margin-bottom: 10px;
}

.el-input__inner {
  border: none;
}

.pc-login .login_center .phone_box /deep/ .el-input__inner {
  border: 0 !important;
  font-size: 18px;
  height: 50px;
  background: #f7f6f9;
}

.switchover,
.forget-tab {
  display: block;
  color: #333;
  font-size: 15px;
}

.forget-tab {
  font-style: italic;
}

@function rem($size, $rem: 37.5) {
  @return $size / $rem + rem;
}

@media screen and (max-width: 680px) {
  .login {
    .login_center {
      width: rem(360);
      height: rem(400);
      border-radius: rem(20);
      padding: rem(19) rem(30) 0 rem(30);

      .logo-img {
        border-radius: 50%;
        height: rem(100);
        width: rem(100);
        top: rem(-50);
      }

      .header {
        font-size: rem(18);
        margin: rem(50) 0;
      }

      .send {
        font-size: rem(16);
      }
    }

    button {
      font-size: rem(18);
    }
  }

  .span-password {
    margin-top: -20px;
    margin-bottom: 10px;
  }

  .el-input__inner {
    border: none;
  }

  .pc-login .login_center .phone_box /deep/ .el-input__inner {
    border: 0 !important;
    font-size: 18px;
    height: 50px;
    background: #f7f6f9;
  }

  .switchover,
  .forget-tab {
    font-size: rem(14);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/computer/PcLogin.vue